import React, { useState } from "react";

//Services
import api from "../services/api";

//Sweet alert
import Swal from "sweetalert2";

//Components
import {
  Input,
  Button
} from "../components";

//React router
import {
  Link,
  useNavigate,
  useSearchParams
} from "react-router-dom";

import {
  useForm
} from "react-hook-form";

import {
  yupResolver
} from "@hookform/resolvers/yup";

import * as yup from "yup";
import useLocalStorage from "use-local-storage";

const schema = yup.object({
  new_password: yup.string().required("O campo nova senha precisa ser preenchido."),
  new_password_again: yup.string().required("O campo repetir nova senha precisa ser preenchido.").oneOf([yup.ref("new_password"), null], "As senhas não batem."),
}).required();

const RedefinePassword = (props) => {
  let navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const [loading, setLoading] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  const onSubmit = async data => {
    setLoading(true);

    let forget = searchParams.get("forget");

    const { new_password, new_password_again } = data;

    try {
      const response = await api.post("/password/change", {
        forget,
        password: new_password,
        newpassword: new_password_again
      });

      if (response.data.error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      } else {
        let icon = "success";
        let title = "Sucesso";
        let text = response.data.message;

        openAlert(icon, title, text);
        navigate("/");
      }

    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const [theme] = useLocalStorage("theme");

  return (
    <div className="container-signin" data-theme={theme}>
      <Link className="back-link" to="/">
        ← redefinir senha
      </Link>

      <p className="p-info">
        Insira uma nova senha forte.
      </p>

      <div className="white-box mt-1">
        <form onSubmit={handleSubmit(onSubmit)}>

          <Input
            label="Nova senha"
            type="password"
            placeholder="exemplo123"
            name="new_password"
            register={register}
            error={errors.new_password} />

          <Input
            label="Repetir nova senha"
            type="password"
            placeholder="exemplo123"
            name="new_password_again"
            register={register}
            error={errors.new_password_again} />

          <div className="mt-20"></div>

          <Button
            title="Redefinir senha"
            color="red"
            width="full"
            loading={loading} />

        </form>
      </div>

    </div>
  );
}

export default RedefinePassword;